import useLocalization from "@/hooks/useLocalization";
import useSettings from "@/hooks/useSettings";
import { reservationEmailSettings } from "@/providers/SettingsProvider/reservationEmailSettings";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";

export default function NotificationSettings() {
  const { t } = useLocalization();
  const { settings, toggleReservationEmailSetting } = useSettings();

  return (
    <FormGroup>
      {reservationEmailSettings.map((settingsKey) => (
        <FormControlLabel
          key={settingsKey}
          control={
            <Checkbox
              checked={!!settings?.[settingsKey]}
              onClick={() => toggleReservationEmailSetting(settingsKey)}
            />
          }
          label={t(`settings:${settingsKey}`)}
        />
      ))}
      {settings?.receiveNewReservationEmails === false && (
        <FormHelperText>{t("settings:newReservationEmailsOff")}</FormHelperText>
      )}
    </FormGroup>
  );
}
